export interface Point {
  x: number;
  y: number;
}

export class IsometricMath {
  static cellToScreen(col: number, row: number, tileWidth: number, tileHeight: number): Point {
    const x = (col - row) * (tileWidth / 2);
    const y = (col + row) * (tileHeight / 2);
    return { x, y };
  }

  static screenToCell(screenX: number, screenY: number, tileWidth: number, tileHeight: number): { col: number; row: number } {
    const col = (screenX / (tileWidth / 2) + screenY / (tileHeight / 2)) / 2;
    const row = (screenY / (tileHeight / 2) - screenX / (tileWidth / 2)) / 2;
    return {
      col: Math.floor(col + 0.5),
      row: Math.floor(row + 0.5)
    };
  }

  static getDiamondCorners(centerX: number, centerY: number, tileWidth: number, tileHeight: number): Point[] {
    const halfWidth = tileWidth / 2;
    const halfHeight = tileHeight / 2;

    return [
      { x: centerX, y: centerY - halfHeight },
      { x: centerX + halfWidth, y: centerY },
      { x: centerX, y: centerY + halfHeight },
      { x: centerX - halfWidth, y: centerY }
    ];
  }

  static getTileWidth(cellSize: number): number {
    return cellSize * 2;
  }

  static getTileHeight(cellSize: number): number {
    return cellSize;
  }

  static manhattanDistance(col1: number, row1: number, col2: number, row2: number): number {
    return Math.abs(col1 - col2) + Math.abs(row1 - row2);
  }

  static chebyshevDistance(col1: number, row1: number, col2: number, row2: number): number {
    return Math.max(Math.abs(col1 - col2), Math.abs(row1 - row2));
  }
}
